import { Button, Col, Row, message } from "antd";
import React, { useState } from "react";
import PatientService from "../../../Services/PatientService";

function FilterPatient({
  setPatientData,
  handleFilterCancel,
  setLoading,
  setSearchAttempted,
}) {
  const [formValues, setFormValues] = useState({
    patientId: "",
    firstName: "",
    email: "",
    mobile: "",
  });

  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    handleFilterCancel();
    setFormValues({
      patientId: "",
      firstName: "",
      email: "",
      mobile: "",
    });
  };

  const handleFinish = async () => {
    const { patientId, firstName, email, mobile } = formValues;

    if (!patientId && !email && !mobile && !firstName) {
      message.error("Enter any details to filter");
      return;
    }

    setSearchAttempted(true);
    setLoading(true);

    const payload = {
      ...formValues,
      account_Id: loginResultObject?.user?.account_Id,
      // clinic_Id: loginResultObject?.user?.clinic_Id,
    };

    try {
      const res = await PatientService.PatientListFilter(payload);
      setPatientData(res?.data || []);
    } catch (error) {
      console.error(error);
      message.error("Error occurred... try again");
      setPatientData([]);
    } finally {
      setLoading(false);
      handleFilterCancel();
      handleCancel();
    }
  };

  return (
    <form
      className="formDesign w-[452px]"
      onSubmit={(e) => {
        e.preventDefault();
        handleFinish();
      }}
    >
      <Row gutter={20}>
        <Col span={12}>
          <div className="relative mt-4">
            <input
              className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
              name="patientId"
              type="text"
              id="patientId"
              placeholder=""
              value={formValues.patientId}
              onChange={handleInputChange}
            />

            <label
              htmlFor="patientId"
              className="absolute left-3 -top-3 text-blue-500 bg-white px-1 transition-all 
            peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
            peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
            >
              Patient ID
            </label>
          </div>
        </Col>

        <Col span={12}>
          <div className="relative mt-4">
            <input
              className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
              name="firstName"
              type="text"
              id="firstName"
              placeholder=""
              value={formValues.firstName}
              onChange={handleInputChange}
            />

            <label
              htmlFor="firstName"
              className="absolute left-3 -top-3 text-blue-500 bg-white px-1 transition-all 
            peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
            peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
            >
              FirstName
            </label>
          </div>
        </Col>

        <Col span={12}>
          <div className="relative mt-4">
            <input
              className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
              name="email"
              type="text"
              id="email"
              placeholder=""
              value={formValues.email}
              onChange={handleInputChange}
            />

            <label
              htmlFor="email"
              className="absolute left-3 -top-3 text-[#189FAA] bg-white px-1 transition-all 
            peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
            peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
            >
              Email
            </label>
          </div>
        </Col>

        <Col span={12}>
          <div className="relative mt-4">
            <input
              className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
              name="mobile"
              type="text"
              id="mobile"
              placeholder=""
              value={formValues.mobile}
              onChange={handleInputChange}
            />

            <label
              htmlFor="mobile"
              className="absolute left-3 -top-3 text-[#189FAA] bg-white px-1 transition-all 
            peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
            peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
            >
              Mobile
            </label>
          </div>
        </Col>
      </Row>

      <div className="flex justify-end border-brand-colorBorder gap-3 pt-4">
        <button
          className="h-[32px] Btnwhite rounded-sm w-[82px] border-gray-600 border-2 "
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className="h-[32px] w-[118px] text-white rounded-sm"
          type="primary"
          htmlType="submit"
        >
          Filter
        </button>
      </div>
    </form>
  );
}

export default FilterPatient;
